import { useEffect, useRef, useState } from 'react';
import { getGallery } from '../services/api';

const defaultGallery = [
  { src: 'https://images.unsplash.com/photo-1565891741441-64926e441838?w=800&q=80', alt: 'Manufacturing Floor' },
  { src: 'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=800&q=80', alt: 'Industrial Machinery' },
  { src: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&q=80', alt: 'Engineering Team' },
  { src: 'https://images.unsplash.com/photo-1565793298595-6a879b1d9492?w=800&q=80', alt: 'Quality Control' },
  { src: 'https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=800&q=80', alt: 'Production Line' },
  { src: 'https://images.unsplash.com/photo-1530124566582-a618bc2615dc?w=800&q=80', alt: 'Workshop' },
  { src: 'https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?w=800&q=80', alt: 'Assembly Process' },
  { src: 'https://images.unsplash.com/photo-1567789884554-0b844b597180?w=800&q=80', alt: 'Precision Tools' },
];

const Gallery = () => {
  const sectionRef = useRef(null);
  const [gallery, setGallery] = useState([]);

  useEffect(() => {
    getGallery().then(res => {
      if (res && res.length > 0) {
        setGallery(res.map(g => ({ src: g.image, alt: g.caption || g.title })));
      }
    });
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.1, rootMargin: '0px 0px -30px 0px' }
    );
    if (sectionRef.current) {
      const els = sectionRef.current.querySelectorAll('.rv');
      els.forEach(el => observer.observe(el));
      return () => els.forEach(el => observer.unobserve(el));
    }
  }, [gallery]);

  const items = gallery.length > 0 ? gallery : defaultGallery;

  return (
    <section id="gallery" ref={sectionRef} style={{paddingTop:'0', paddingBottom:'80px', background:'var(--white)'}}>
      <div className="wrap">
        <div className="about-gallery rv" style={{marginBottom:'40px'}}>
          <div className="slide-index" style={{color:'var(--yd)',justifyContent:'center'}}><span></span> Our Gallery</div>
          <h2 className="heading" style={{textAlign:'center',marginBottom:'0'}}>
            Behind <em>The Scenes</em>
          </h2>
        </div>
      </div>
      <div className="gallery-marquee-outer rv">
        <div className="gallery-marquee-track">
          {[...items, ...items].map((img, i) => (
            <div className="gallery-item" key={i}>
              <img src={img.src} alt={img.alt} />
              <div className="gallery-caption">{img.alt}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
